import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  // Lock body scroll while the consent modal is mandatory.
  useEffect(() => {
    if (showBanner) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [showBanner]);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
    } catch (e) {
      // localStorage unavailable (private mode) — banner won't persist but we still allow continuation
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('cookieConsent: localStorage unavailable', e);
      }
    }
    if (window.posthog && typeof window.posthog.opt_in_capturing === 'function') {
      try {
        window.posthog.opt_in_capturing();
        window.posthog.capture('$pageview');
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('cookieConsent: PostHog opt-in failed', e);
        }
      }
    }
    setShowBanner(false);
  };

  const handleDecline = () => {
    try {
      localStorage.setItem('cookieConsent', 'declined');
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('cookieConsent: localStorage unavailable', e);
      }
    }
    if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
      try { window.posthog.opt_out_capturing(); } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('cookieConsent: PostHog opt-out failed', e);
        }
      }
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      className="cookie-consent-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-consent-title"
      data-testid="cookie-consent-modal"
    >
      <div className="cookie-consent-banner">
        <div className="cookie-content">
          <h3 id="cookie-consent-title" className="cookie-title">We value your privacy</h3>
          <p className="cookie-text">
            We use cookies to enhance your browsing experience, serve personalised content, and
            analyse our traffic. Please choose how you'd like to continue. By clicking
            "Accept All", you consent to our use of cookies. You can decline non-essential cookies.
          </p>
          <button
            type="button"
            onClick={() => navigate('/privacy-policy')}
            className="cookie-link"
            data-testid="cookie-privacy-link"
          >
            Read our Privacy Policy
          </button>
        </div>

        <div className="cookie-buttons">
          <Button
            onClick={handleDecline}
            className="cookie-btn-decline"
            data-testid="cookie-decline-btn"
          >
            Decline
          </Button>
          <Button
            onClick={handleAccept}
            className="cookie-btn-accept"
            data-testid="cookie-accept-btn"
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
